exports.LoginMethod = {
  email: 'Email',
  facebook: 'Facebook',
  google: 'Google'
}